import { SxProps } from '@mui/material'

import theme from '../../../../shared/styles/themes/default.theme'

const styles = {
  accordionHeaderMainContent: {
    textAlign: 'left',
    [theme.breakpoints.down('md')]: {
      fontWeight: theme.typography.fontWeightBold,
      paddingLeft: theme.spacing(2)
    }
  } as SxProps,

  statusChip: (backgroundColor: string, textColor: string) =>
    ({
      backgroundColor,
      color: textColor,
      fontWeight: 500,
      fontSize: '0.75rem',
      height: 24
    }) as SxProps,

  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5)
  } as SxProps,

  itemsContainer: {
    gap: theme.spacing(1.5),
    display: 'flex',
    flexDirection: 'column'
  } as SxProps,

  itemRow: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: theme.spacing(2),
    padding: theme.spacing(1.75),
    backgroundColor: '#FAFAFA',
    borderRadius: theme.spacing(1),
    border: '1px solid #F3F4F6'
  } as SxProps,

  itemImage: {
    width: 50,
    height: 50,
    borderRadius: theme.spacing(0.75),
    objectFit: 'cover' as const,
    backgroundColor: theme.palette.grey[200],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0
  } as SxProps,

  itemImageContent: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    borderRadius: 'inherit'
  } as SxProps,

  itemImagePlaceholder: {
    color: theme.palette.grey[400],
    fontSize: 24
  },

  itemInfo: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0.25,
    flex: 1,
    minWidth: 0
  } as SxProps,

  itemTitle: {
    fontSize: '0.875rem',
    fontWeight: 500,
    color: theme.palette.grey[800],
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    textAlign: 'left'
  } as SxProps,

  itemMeta: {
    fontSize: '0.75rem',
    color: theme.palette.grey[500],
    textAlign: 'left'
  } as SxProps,

  footerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%'
  } as SxProps,

  footerTrackTitle: {
    fontSize: '0.875rem',
    fontWeight: 500,
    color: theme.palette.grey[700]
  } as SxProps,

  trackingDetailsContainer: {
    padding: theme.spacing(2, 0, 0, 0)
  } as SxProps,

  travelerDetailsContainer: {
    padding: theme.spacing(1, 2),
    borderRadius: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: theme.palette.grey[100],
    marginBottom: 0,
    gap: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      flexWrap: 'wrap'
    },
    width: '100%'
  } as SxProps,

  travelerDetailsWrapper: {
    display: 'flex',
    alignItems: 'center'
  } as SxProps,

  travelerDetailsTextContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  } as SxProps,

  travelerDetailsName: {
    fontWeight: 'bold',
    fontSize: '0.9rem'
  } as SxProps,

  travelerDetailsTag: {
    fontSize: '0.8rem',
    color: 'text.secondary'
  } as SxProps,

  sectionDivider: {
    margin: theme.spacing(0.5, 0)
  } as SxProps,

  itemLoadingSkeleton: {
    borderRadius: '6px',
    flexShrink: 0
  } as SxProps,

  itemLoadingTextContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: 0.5
  } as SxProps,

  trackingLoaderContainer: {
    padding: 2
  } as SxProps,

  trackingLoaderTitle: {
    marginBottom: 2
  } as SxProps,

  trackingLoaderStepsContainer: {
    display: 'flex',
    gap: 2,
    justifyContent: 'space-between'
  } as SxProps,

  trackingLoaderProgress: {
    marginTop: 1
  } as SxProps,

  footerMainContent: {
    width: '100%'
  } as SxProps,

  orderDetailsSubtitleContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
    width: '100%'
  } as SxProps,

  orderDetailsSubtitleText: {
    fontSize: '0.8125rem',
    color: theme.palette.grey[500],
    fontWeight: 400
  } as SxProps,

  recipientDetailsContainer: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: theme.spacing(1),
    backgroundColor: '#F9FAFB',
    border: '1px solid #E5E7EB',
    overflow: 'hidden'
  } as SxProps,

  recipientDetailRow: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.5),
    padding: theme.spacing(2, 2.5)
  } as SxProps,

  recipientDetailLabelText: {
    fontSize: '0.75rem',
    fontWeight: 500,
    color: theme.palette.grey[400],
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  } as SxProps,

  recipientDetailValueText: {
    fontSize: '0.9375rem',
    fontWeight: 500,
    color: theme.palette.grey[800],
    lineHeight: 1.5,
    whiteSpace: 'pre-line'
  } as SxProps,

  recipientDetailDivider: {
    margin: 0,
    borderColor: '#E5E7EB'
  } as SxProps
}

export default styles
